/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_RegionInputs */

const cs_form_region = /** @type {(inputs: Form_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kraj`)
};

const en_form_region = /** @type {(inputs: Form_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

/**
* | output |
* | --- |
* | "Region" |
*
* @param {Form_RegionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_region = /** @type {((inputs?: Form_RegionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_RegionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_region(inputs)
	return cs_form_region(inputs)
});